import {useWorkTimeTimer} from '../hooks/useWorkTimeTimer';

type LiveDurationProps = {
  startedAt?: string;
};

function LiveDuration({startedAt}: LiveDurationProps) {
  const duration = useWorkTimeTimer(startedAt);

  return <>{duration}</>;
}

export default LiveDuration;
